import React from 'react';
import about from '../images/about_org.jpg';
import consulting from '../images/consulting.avif';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function Staffing() {
  useDocTitle("Staffing and IT Solutions");

  return (
    <div>
      {/* Hero Section */}
     <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

        <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
  <h2 className={`${commonStyles.pageTitle} text-white`}>
    Staffing and IT Solutions
  </h2>
</div>
      </div>
<CommonContainer>
      {/* Section Title */}
      {/* <div className="mt-16">
        <p className="font-bold text-blue-500 mb-6 text-center
                      text-lg md:text-xl lg:text-2xl">
          Staffing and IT Solutions
        </p>
      </div> */}

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row items-center
              my-8 gap-8">

        {/* Image */}
        <div className="w-full lg:w-1/2 my-5">
          <img
            src={consulting}
            alt="Staffing"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Text */}
        <div className="w-full lg:w-1/2">

  <h1 className={`${commonStyles.heading} mb-6`}>
    Staffing and IT Solutions
  </h1>
          <p className={`${commonStyles.paragraph} mb-4`}>
            We understand that the key to profitability in an increasingly
            competitive and complicated market is the ability to fluidly deploy
            resources to address precise business and technological challenges.
            With a strong team of capable and experienced professionals ready for
            deployment across the globe, QuadProsoft is prepared to help you meet
            challenges related to organizational scaling and technological
            complexity.
          </p>
      </div>
      </div>

      {/* Additional Content */}
     <div>
        <p className={`${commonStyles.paragraph} mb-4`}>
          With us, it is never enough to hire a brilliant and experienced mind.
          Given the speed at which change occurs in today’s business world,
          staying updated with emerging trends can itself be daunting.
          QuadProsoft invests consistently in training its consultants, ensuring
          they remain aligned with evolving technologies. This investment has
          resulted in customers reporting high satisfaction with the quality,
          speed, and precision of the solutions delivered.
        </p>

       <p className={`${commonStyles.paragraph} mb-4`}>
          Whether your requirement is onsite staffing, temporary contract
          consultants for specific projects, or offshore consultants working in
          custom-bound areas, QuadProsoft Technologies has the resources to meet
          all your staffing needs.
        </p>
      </div>

      {/* Contact */}
     <div className="my-10">
       <p className={`${commonStyles.paragraph} mb-4`}>
          To find out more about our outsourced staffing, please{' '}
          <a
            href="/contact"
            className="text-blue-500 hover:underline"
          >
            contact us
          </a>.
        </p>
      </div>
      </CommonContainer>
    </div>
  );
}

export default Staffing;
